import React from "react";
import { convertKBtoGo } from "../../utils/convertiseur";
import { Badge } from "primereact/badge";
import { Tooltip } from "primereact/tooltip";
import { Tag } from "primereact/tag";
import moment from "moment";
import "moment/locale/fr";
import { FilterMatchMode, FilterOperator } from "primereact/api";

const getStatusInfo = (status) => {
  switch (status?.split(".").pop()) {
    case "A_TRAITER":
      return (
        <>
          <Tooltip target=".custom-target-icon" />

          <Badge
            data-pr-tooltip="Document à traiter"
            className="custom-target-icon "
            severity="info"
            value={"A traiter"}
          />
        </>
      );

    case "EN_COURS":
      return (
        <>
          <Tooltip target=".custom-target-icon" />

          <Badge
            data-pr-tooltip="Document en cours de traitement"
            className="custom-target-icon "
            severity="warning"
            value={"En cours"}
          />
        </>
      );

    case "ACTIF_EN_ATTENTE":
      return (
        <>
          <Tooltip target=".custom-target-icon" />

          <Badge
            data-pr-tooltip="Document validé et en attente de création d'actif"
            className="custom-target-icon"
            severity="success"
            value={"Validé"}
          />
        </>
      );

    default:
      return null;
  }
};

const getFichierValue = (fichier) => {
  switch (fichier?.pertinence_fichier?.split(".").pop()) {
    case "NON_PERTINENT":
      return "non pertinent";

    case "INCOMPLET":
      return "incomplet";

    case "PERTINENT":
      return "pertinent";

    default:
      return null;
  }
};

const getFichierSeverity = (fichier) => {
  switch (fichier?.pertinence_fichier?.split(".").pop()) {
    case "NON_PERTINENT":
      return "danger";

    case "INCOMPLET":
      return "warning";

    case "PERTINENT":
      return "success";

    default:
      return null;
  }
};

const ficherBodyTemplate = (rowData) => {
  return (
    <div className="flex items-center w-full  space-x-3 transition-colors duration-200   ">
      <img className=" w-6 h-6" src="/images/fichier.png" alt="fichier" />
      <div className="text-left rtl:text-right">
        <h1 className="text-md font-semibold text-gray-700 capitalize ">
          {rowData?.nom_fichier}
        </h1>
        <p className="text-sm text-gray-400 ">{convertKBtoGo(rowData?.size)}</p>
      </div>
      <div>{getStatusInfo(rowData?.status_fichier)}</div>
    </div>
  );
};

const representativeBodyTemplate = (rowData) => {
  const user = rowData?.user;

  return (
    <>
      {rowData?.user_id !== null ? (
        <div className="flex space-x-2">
          <img
            className="object-cover w-8 h-8 rounded-full"
            src={user.photo_user ? user.photo_user : "/images/profile.png"}
          />
          <div className="text-left rtl:text-right">
            <h1 className="text-sm font-semibold text-gray-700 capitalize dark:text-white">
              {user?.first_name + " " + user?.last_name}
            </h1>
          </div>
        </div>
      ) : null}
    </>
  );
};

const aperçuBodyTemplate = (rowData) => {
  return (
    <>
      <a
        href={rowData?.url_ressources}
        target="_blank"
        rel="noopener noreferrer"
      >
        Aperçu fichier
      </a>
    </>
  );
};

const pertinenceFichierBodyTemplate = (rowData) => {
  return (
    // <Tag
    //   value={getFichierValue(rowData)}
    //   severity={getFichierSeverity(rowData)}
    //   rounded
    // />
    <Tag value="Pertinent" severity="success" rounded />
  );
};

export const filtersFichier = {
  global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  nom_fichier: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
  },
  date_importation: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
  },

  status_fichier: {
    operator: FilterOperator.OR,
    constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
  },
  extensions: {
    operator: FilterOperator.OR,
    constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
  },

  scoring_fichier: { value: null, matchMode: FilterMatchMode.BETWEEN },
};

export const columnsFileds = [
  {
    field: "nom_fichier",
    header: "Nom du fichier",
    style: { flexGrow: 1, flexBasis: "120px" },
    body: (rowData) => ficherBodyTemplate(rowData),
    editor: null,
    sortable: -1,
    filter: false,
  },

  {
  field: "description",
  header: "Description",
  style: { flexGrow: 2, flexBasis: "200px" },
  body: (rowData) => (
    <span className="text-sm text-gray-600">
      {rowData?.description || "-"}
    </span>
  ),
  sortable: -1,
},

  {
    field: "extensions",
    header: "Format de fichier",
    style: { flexGrow: 1, flexBasis: "120px" },
    body: (rowData) => rowData?.extensions?.toUpperCase(),
    editor: null,
    sortable: -1,
  },
  {
    field: "user_id",
    header: "Importé par",
    style: { flexGrow: 1, flexBasis: "120px" },
    body: (rowData) => representativeBodyTemplate(rowData),
    editor: null,
    sortable: -1,
  },
  {
    field: "date_importation",
    header: "Date d'importation",
    style: { flexGrow: 1, flexBasis: "120px" },
    body: (rowData) => moment(rowData?.date_importation).format("L"),
    editor: null,
    sortable: -1,
  },

 /* {
    field: "pertinence_fichier",
    header: "Pertinence",
    style: { flexGrow: 1, flexBasis: "120px" },
    body: (rowData) => pertinenceFichierBodyTemplate(rowData),
    sortable: -1,
  },*/
];
